import { FI18n } from '@freelog/tools-lib';
import type { NodeManagerModelState } from './types';
import { resourceTypeCodes_all2 } from '@/components/FResourceTypeFilter3';

export const exhibitInitStates: Pick<
  NodeManagerModelState,
  | 'exhibit_ResourceTypeCodes'
  | 'exhibit_ResourceStateOptions'
  | 'exhibit_SelectedStatus'
  | 'exhibit_InputFilter'
  | 'exhibit_List'
  | 'exhibit_ListTotal'
  | 'exhibit_ListState'
  | 'exhibit_ListMore'
  | 'isBatchManagement'
  | 'checkedExhibitIDs'
  | 'updateExhibitResultType'
  | 'updateExhibitResult'
> = {
  exhibit_ResourceTypeCodes: resourceTypeCodes_all2,
  exhibit_ResourceStateOptions: [
    {
      text:
        // '全部'
        FI18n.i18nNext.t('filte_exhibitstates_option_all'),
      value: '2',
    },
    { text: FI18n.i18nNext.t('filter_exhibit_status_availableforauth'), value: '1' },
    { text: FI18n.i18nNext.t('filter_exhibit_status_pendingauth'), value: '0' },
  ],
  exhibit_SelectedStatus: '2',
  exhibit_InputFilter: '',
  exhibit_List: [],
  exhibit_ListTotal: -1,
  exhibit_ListState: 'loading',
  exhibit_ListMore: 'loading',
  isBatchManagement: false,
  checkedExhibitIDs: [],
  updateExhibitResultType: '',
  updateExhibitResult: null,
};

export const themeInitStates: Pick<
  NodeManagerModelState,
  | 'theme_ActivatingThemeID'
  | 'theme_InputFilter'
  | 'theme_List'
  | 'theme_ListState'
  | 'theme_ListMore'
> = {
  theme_InputFilter: '',
  theme_ActivatingThemeID: '',
  theme_List: [],
  theme_ListState: 'loading',
  theme_ListMore: 'loading',
};

export const contractInitStates: Pick<
  NodeManagerModelState,
  | 'contract_ShowPage'
  | 'contract_Authorize_Status_Options'
  | 'contract_Authorize_Status'
  | 'contract_Authorize_Date'
  | 'contract_Authorize_Keywords'
  | 'contract_Authorize_ListState'
  | 'contract_Authorize_ListMore'
  | 'contract_Authorize_List'
  | 'contract_Authorized_Status_Options'
  | 'contract_Authorized_Status'
  | 'contract_Authorized_Date'
  | 'contract_Authorized_Keywords'
  | 'contract_Authorized_ListState'
  | 'contract_Authorized_ListMore'
  | 'contract_Authorized_List'
  | 'contract_ContractDetailsID'
> = {
  contract_ShowPage: 'authorize',

  contract_Authorize_Status_Options: [
    {
      value: 'all',
      text: '全部',
    },
    {
      value: 'authorized',
      text: '已授权',
    },
    {
      value: 'unauthorized',
      text: '未授权',
    },
    {
      value: 'terminated',
      text: '已终止',
    },
  ],
  contract_Authorize_Status: 'all',
  contract_Authorize_Date: null,
  contract_Authorize_Keywords: '',
  contract_Authorize_ListState: 'loading',
  contract_Authorize_ListMore: 'loading',
  contract_Authorize_List: [],

  contract_Authorized_Status_Options: [
    {
      value: 'all',
      text: '全部',
    },
    {
      value: 'authorized',
      text: '已授权',
    },
    {
      value: 'unauthorized',
      text: '未授权',
    },
    {
      value: 'terminated',
      text: '已终止',
    },
  ],
  contract_Authorized_Status: 'all',
  contract_Authorized_Date: null,
  contract_Authorized_Keywords: '',
  contract_Authorized_ListState: 'loading',
  contract_Authorized_ListMore: 'loading',
  contract_Authorized_List: [],

  contract_ContractDetailsID: '',
};

export const settingInitStates: Pick<
  NodeManagerModelState,
  | 'setting_nodeID'
  | 'setting_pageState'
  | 'setting_nodeName'
  | 'setting_nodeUrl'
  | 'setting_state'
  | 'setting_editingModules'
  | 'setting_nodeInfo'
  | 'setting_nodeCover'
  | 'setting_nodeTitle'
  | 'setting_nodeTitle_Error'
  | 'setting_nodeIntroduction'
  | 'setting_nodeLimitation'
  | 'setting_nodeLimitationMessage'
  | 'setting_coverImage'
  | 'setting_exhibitMatchTags'
> = {
  setting_nodeID: -1,
  setting_pageState: 'loading',
  setting_nodeName: '',
  setting_nodeUrl: '',
  setting_state: 'normal',
  setting_editingModules: [],
  setting_nodeInfo: {
    cover: '',
    title: '',
    introduction: '',
    limitation: 'public',
    limitationMessage: '',
    coverImage: '',
    exhibitMatchTags: [],
  },
  setting_nodeCover: '',
  setting_nodeTitle: '',
  setting_nodeTitle_Error: '',
  setting_nodeIntroduction: '',
  setting_nodeLimitation: 'public',
  setting_nodeLimitationMessage: '',
  setting_coverImage: '',
  setting_exhibitMatchTags: [],
};

export const initialState: NodeManagerModelState = {
  nodeId: -1,

  nodeCover: '',
  nodeName: '',
  nodeTitle: '',
  nodeUrl: '',
  testNodeUrl: '',
  nodeThemeId: '',
  node_limitation: 'public',
  showPage: 'exhibit',
  goToTestNodePage: '',
  nodeInfoState: 'loading',
  // listFirstLoaded: false,

  ...exhibitInitStates,

  ...themeInitStates,

  ...contractInitStates,

  policyEditorVisible: false,
  policyOperaterVisible: false,

  ...settingInitStates,
};
